<template>
  <section class="app-main">
    <el-alert v-if="(role === 'Superadmin' || role === 'Admin') && total > 0" style="margin: 10px;"
      :title="alert"
      type="error" effect="dark" show-icon>
    </el-alert>
    <transition name="fade-transform" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import * as trackingApi from '@/api/tracking'

export default {
  name: 'AppMain',
  computed: {
    ...mapGetters([
      'role'
    ])
  },
  data() {
    return {
      alert: '',
      total: 0
    }
  },
  async created() {
    setInterval(async() => {
      trackingApi.unknown()
        .then(resp => {
          this.total = resp.total
          this.alert = `There are ${resp.total} unknown tracking numbers. Please check.`
        })
    }, 5000)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue